module.exports = __webpack_public_path__ + "static/media/searchLocation.4eb5e0d5.svg";